<div>
  <i *ngIf="palletType === 'pallet'" class="icon-pallet" [class]="iconSize"></i>
  <i *ngIf="palletType === 'roll'" class="icon-roll" [class]="iconSize"></i>
  <i *ngIf="palletType === 'liquid'" class="icon-drop" [class]="iconSize"></i>
  <i *ngIf="palletType === 'tool'" class="icon-nav-settings" [class]="iconSize"></i>
  <i *ngIf="palletType === 'container'" class="icon-container" [class]="iconSize"></i>
</div>
